import { motion } from "framer-motion";
import { LucideIcon } from "lucide-react";

interface StatCardProps {
  label: string;
  value: string | number;
  icon: LucideIcon;
  color?: "brand" | "indigo" | "emerald" | "amber" | "rose" | "purple";
  delay?: number;
}

const colorMap = {
  brand: "text-brand-600 bg-brand-50 shadow-brand-500/15",
  indigo: "text-indigo-600 bg-indigo-50 shadow-indigo-500/15",
  emerald: "text-emerald-600 bg-emerald-50 shadow-emerald-500/15",
  amber: "text-amber-600 bg-amber-50 shadow-amber-500/15",
  rose: "text-rose-600 bg-rose-50 shadow-rose-500/15",
  purple: "text-purple-600 bg-purple-50 shadow-purple-500/15",
};

export function StatCard({ label, value, icon: Icon, color = "brand", delay = 0 }: StatCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay, duration: 0.4 }}
      className="surface-card p-5 flex items-center gap-4"
    >
      <div
        className={`w-12 h-12 rounded-2xl flex items-center justify-center ${colorMap[color]}`}
        style={{
          boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.5), 0 8px 24px -6px currentColor",
        }}
      >
        <Icon size={33} />
      </div>
      <div>
        <p className="text-2xl font-bold text-slate-800">{value}</p>
        <p className="text-sm text-slate-500 font-medium">{label}</p>
      </div>
    </motion.div>
  );
}
